import { type CancellablePromise, post } from "@/api";
import type { Suggestion, SuggestionType } from "@/types";

export function getSuggestions(query: string, methodIds: string[]): CancellablePromise<Suggestion[]> {
  return post<Suggestion[]>("/v1/suggestions", { query, methodIds });
}

export function logSuggestion(
  uuid: string,
  selectedSuggestion: string,
  index: number,
  engine: SuggestionType
): CancellablePromise<void> {
  return post<void>("/v1/suggestions/log-selection", { uuid, selectedSuggestion, index, engine });
}
